<template>
<div class="chapter">
<div class="inner_page">
<p class="copy">Copyright © 2005 by Marc W. Kirschner and John C. Gerhart. Illustrations copyright © John Norton. All rights reserved.<br/><br/></p>
<p class="copy">This book may not be reproduced, in whole or in part, including illustrations, in any form (beyond that copying permitted by Sections 107 and 108 of the U.S. Copyright<br/>Law and except by reviewers for the public press), without written permission from the publishers.<br/><br/></p>
<p class="copy">Designed by Sonia Shannon<br/>Set in Bulmer type by Binghamton Valley Composition<br/>Printed in the United States of America by Vail-Ballou Press<br/><br/></p>
<p class="copy">Library of Congress Cataloging-in-Publication Data Kirschner, Marc.<br/>The plausibility of life : Resolving Darwin’s Dilemma / Marc W. Kirschner and John C. Gerhart.<br/>p. cm.<br/>Includes bibliographical references (p.).<br/>ISBN 0-300-10865-6 (cloth : alk. paper)<br/>1. Evolution (Biology) 2. Life—Origin. I. Gerhart, John, 1936- II. Title.<br/>QH366.2.K57 2005<br/>576.8—dc22 2005040113<br/><br/></p>
<p class="copy">A catalogue record for this book is available from the British Library.<br/><br/></p>
<p class="copy">The paper in this book meets the guidelines for permanence and durability of the Committee on Production Guidelines for Book Longevity of the Council on Library Resources.<br/><br/></p>
<p class="copy">10   9   8   7   6   5   4   3   2   1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_copyright.vue?4e9fa140